import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  modalSection: {
    paddingTop: "1rem",
    width: "100%",
  },
}));

export default styles;
